module.exports = __webpack_public_path__ + "img/loginBgMobile.7f58b84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loginBgMobile.png
// module id = 5Z3G
// module chunks = 4